import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import { LinearProgress, linearProgressClasses } from '@mui/material';
const StyledLinearProgress = styled(LinearProgress).withConfig({
  componentId: "sc-1dqdctj-0"
})(() => ({
  height: SIZES['2'],
  borderRadius: SIZES['1'],
  width: '100%',
  ['&:not(:last-child)']: {
    marginRight: SIZES['4'],
    '@media only screen and (max-width: 600px)': {
      marginRight: SIZES['2']
    }
  },
  ["&.".concat(linearProgressClasses.colorPrimary)]: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  },
  ["& .".concat(linearProgressClasses.bar)]: {
    borderRadius: SIZES['1'],
    backgroundColor: COLORS.white
  }
}));
export const ProgressBar = _ref => {
  let {
    progress
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledLinearProgress, {
    variant: "determinate",
    value: progress,
    "data-sentry-element": "StyledLinearProgress",
    "data-sentry-component": "ProgressBar",
    "data-sentry-source-file": "ProgressBar.tsx"
  });
};